import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import PersonIcon from '@mui/icons-material/Person';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import ShareOutlined from '@mui/icons-material/ShareOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import { Box, Chip, Divider, Grid, IconButton, styled, Tooltip } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { LuExternalLink } from 'react-icons/lu';
import { MdOutlineArrowBackIos, MdOutlineArrowForwardIos, MdDoNotDisturbOn } from 'react-icons/md';
import { TbSend } from 'react-icons/tb';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { amplitude } from 'wisestep-api';
import {
  getSocialIconByURL,
  WsButton,
  WsColors,
  WsDrawer,
  WsIconText,
  WsElementWithPopOver,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
  WsIconEmailOutlined,
  WsIconCopy,
  RecruiterQuestionIcon,
  WsChip,
  WsChipVariants,
  formatPhoneNumber,
} from 'wisestep-base';

import { accessDeniedNotoficationTxt } from '../../../../../components/AccessControl/AccessControl';
import CircularImage from '../../../../../components/WsCustomImage/CircularImage';
import { useCandidateViewData } from '../../../../../features/candidateLayout/utils/CandidateViewContext';
import MapConversationIcon from '../../../../../features/conversationWidget/components/MapConversationIcon';
import UpdateMapConversationIcon from '../../../../../features/conversationWidget/components/UpdateMapConversationIcon';
import { useCandidateAts, CandidateAtsAccess } from '../../../../../hooks/useCandidateAts';
import { warning, success } from '../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../utils/NotificationStore';
import { useConversationWidgetStore } from '../../../../../utils/useConversationWidgetStore';
import DataPrivacy from '../../../../conversationWidget/components/DataPrivacy';
import conversationWidgetStore from '../../../../conversationWidget/store/conversationWidgetStore';
// import { mergeFields } from '../../../utils/MergeCandidateHelper';
import CandidateProfileDetailsEdit from '../../childComponets/CandidateProfileDetails/CandidateProfileDetailsEdit';
// import { MergeCandidate } from '../../mergeCandidate';
import { copyStringToClipboard } from '../CandidateDetailsCard/Helper';

import { dncTypes } from './TopBannerHelper';

const Img = styled('img')(() => ({
  height: '25px',
  width: '25px',
  cursor: 'pointer',
  marginRight: '7px',
}));

const IconBox = styled(Box)(() => ({
  display: 'flex',
  float: 'right',
  alignItems: 'center',
  borderColor: 'divider',
  borderRadius: 1,
  backgroundColor: WsColors.IconBackGround,
  color: 'text.secondary',
  padding: 0.5,
}));
interface TopBannerProps {
  setOpenConvoWidget: Dispatch<SetStateAction<boolean>>;
  setOpenJobSelection: Dispatch<SetStateAction<boolean>>;
  setOpenConvoWidgetFlag: Dispatch<SetStateAction<boolean>>;
  isMapped?: boolean;
  setSubmissionPurpose: Dispatch<SetStateAction<string>>;
  setMappingPurpose: Dispatch<SetStateAction<string>>;
}
const TopBanner = ({
  setOpenConvoWidget,
  setOpenJobSelection,
  setOpenConvoWidgetFlag,
  isMapped,
  setSubmissionPurpose,
  setMappingPurpose,
}: TopBannerProps) => {
  const { candidateViewData } = useCandidateViewData();
  const candidate = candidateViewData;
  const [displayListLimit, setDisplayLimit] = useState(2);
  const [formattedPhone, setFormattedPhone] = useState(candidate?.phoneNumber);
  const [openDNC, setOpenDNC] = useState<boolean>(false);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const isSubmitCandidate = useCandidateAts(CandidateAtsAccess.SUBMIT_CANDIDATE);
  const updateAction = useConversationWidgetStore((state) => state.updateAction);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const selectedJob = conversationWidgetStore((state) => state.selectedJob);
  const isInDnc =
    (candidateViewData?.dnc?.isDeleted ?? false) || (candidateViewData?.dnc?.isInDnc ?? false);
  const candidateDncType = candidateViewData?.dnc?.dataPrivacyOption ?? 'open';
  const navigate = useNavigate();

  const handelQuestionResponse = () => {
    updateAction('question');
    if (selectedJob) {
      setOpenConvoWidget(true);
      amplitude('CandidateView_Banner_Recruiter_Questions', {
        clickedOn: 'Recruiter Questions',
        pageName: 'candidate-layout',
        pageUrl: window.location.href,
      });
    } else {
      setOpenJobSelection(true);
      setOpenConvoWidgetFlag(true);
    }
  };

  const icons = [
    {
      icon: <BorderColorOutlinedIcon fontSize="small" />,
      title: 'Update Candidate',
      onclick: () => setOpenDialog(true),
    },
    // {
    //   icon: <BorderColorOutlinedIcon fontSize="small" />,
    //   title: 'Update Candidate',
    //   onclick: () => {
    //     amplitude('CandidateView_Banner_Edit', {
    //       clickedOn: 'Update Candidate',
    //       pageName: 'candidate-layout',
    //       pageUrl: window.location.href,
    //     });
    //   },
    // },
    // {
    //   icon: <BorderColorOutlinedIcon fontSize="small" />,
    //   title: 'Update Candidate',
    //   onclick: () => setOpenDialog(true),
    // },
    {
      icon: <VerifiedUserOutlinedIcon fontSize="small" />,
      title: 'Data Privacy',
      onclick: () => {
        setOpenDNC(!openDNC);
        amplitude('CandidateView_Banner_Data_Privacy', {
          clickedOn: 'Data Privacy',
          pageName: 'candidate-layout',
          pageUrl: window.location.href,
        });
      },
    },
    {
      icon: <ShareOutlined />,
      title: 'Share Candidate',
      onclick: () => {
        updateAction('share');
        if (selectedJob) {
          setOpenConvoWidget(true);
          amplitude('CandidateView_Banner_Share_Candidate', {
            clickedOn: 'Share Candidate',
            pageName: 'candidate-layout',
            pageUrl: window.location.href,
          });
        } else {
          setOpenJobSelection(true);
          setOpenConvoWidgetFlag(true);
        }
      },
    },
    // { icon: <LocalPhoneOutlinedIcon fontSize="small" />, title: 'Phone' },
    {
      icon: <EmailOutlinedIcon fontSize="small" />,
      title: 'Email',
      onclick: () => {
        updateAction('email');
        if (selectedJob) {
          setOpenConvoWidget(true);
          amplitude('CandidateView_Banner_Email', {
            clickedOn: 'Email',
            pageName: 'candidate-layout',
            pageUrl: window.location.href,
          });
        } else {
          setOpenJobSelection(true);
          setOpenConvoWidgetFlag(true);
        }
      },
    },
    {
      icon: <CommentOutlinedIcon fontSize="small" />,
      title: 'Message',
      onclick: () => {
        updateAction('sms');
        if (selectedJob) {
          setOpenConvoWidget(true);
          amplitude('CandidateView_Banner_SMS', {
            clickedOn: 'Message',
            pageName: 'candidate-layout',
            pageUrl: window.location.href,
          });
        } else {
          setOpenJobSelection(true);
          setOpenConvoWidgetFlag(true);
        }
      },
    },
    // {
    //   icon: <TimelineOutlinedIcon fontSize="small" />,
    //   title: 'Map as Lead',
    //   onclick: () => {
    //     setOpenMapping(true);
    //     amplitude('CandidateView_Banner_Mapping', {
    //       clickedOn: 'Map as Lead',
    //       pageName: 'candidate-layout',
    //       pageUrl: window.location.href,
    //     });
    //   },
    // },
    {
      icon: <RecruiterQuestionIcon />,
      title: 'Recruiter Questions',
      onclick: () => handelQuestionResponse(),
    },
    {
      icon: isMapped ? (
        <UpdateMapConversationIcon color={isInDnc ? WsColors.GreyBlack : WsColors.TheBlues500} />
      ) : (
        <MapConversationIcon color={isInDnc ? WsColors.GreyBlack : WsColors.TheBlues500} />
      ),
      title: isMapped ? 'Update conversation' : 'Map as Lead',
      onclick: () => {
        updateAction('mapping');
        if (selectedJob) {
          setOpenConvoWidget(true);
          setMappingPurpose('mapping');
          amplitude('CandidateView_Banner_Map_as_Lead', {
            clickedOn: 'Map as Lead',
            pageName: 'candidate-layout',
            pageUrl: window.location.href,
          });
        } else {
          setOpenJobSelection(true);
          setOpenConvoWidgetFlag(true);
        }
      },
    },
    {
      icon: <TbSend size={20} />,
      title: 'Submit',
      onclick: () => {
        if (isSubmitCandidate) {
          updateAction('submission');
          if (selectedJob) {
            setOpenConvoWidget(true);
          } else {
            setOpenJobSelection(true);
            setOpenConvoWidgetFlag(true);
          }
          setSubmissionPurpose('save');
        } else {
          setNotification(warning(accessDeniedNotoficationTxt));
        }
        amplitude('CandidateView_Banner_Submission', {
          clickedOn: 'Submit',
          pageName: 'candidate-layout',
          pageUrl: window.location.href,
        });
      },
    },
  ];

  // icons =
  //   candidate?.workspaceId === '0ed56aea-54c9-4485-987f-ffb35872eb38'
  //     ? [
  //         ,
  //         ...icons,
  //       ]
  //     : icons;
  const [params] = useSearchParams();

  const openEditDrawer = params.get('openEditDrawer');
  const openEmailWidget = params.get('openEmailWidget');
  useEffect(() => {
    openEditDrawer === 'true' ? setOpenDialog(true) : setOpenDialog(false);
  }, [openEditDrawer]);
  useEffect(() => {
    if (openEmailWidget === 'true') {
      updateAction('email');
      setOpenConvoWidget(true);
    }
  }, [openEmailWidget]);

  useEffect(() => {
    if (candidate?.currentLocation?.countryCode && candidate?.phoneNumber) {
      const updatedPhoneNumber = formatPhoneNumber(
        candidate.currentLocation.countryCode,
        candidate.phoneNumber
      );
      setFormattedPhone(updatedPhoneNumber);
    }
  }, [candidate]);

  const arrayParam = params.get('array');
  const array: string[] = arrayParam ? arrayParam.split(',') : [];
  const id = params.get('id') ?? '';
  const pageTypeMatch = window.location.href.match(/\/candidate-layout\/([^?/]+)/);
  const pageType = pageTypeMatch ? pageTypeMatch[1] : null;

  const nextClick = () => {
    const currentIndex = array?.indexOf(id);
    if (currentIndex > -1 && currentIndex < array.length - 1) {
      navigate(
        `/candidate-layout/${pageType ? pageType : 'profile'}?id=${
          array[currentIndex + 1]
        }&array=${array}${
          params.get('backwardpathArray')
            ? `&backwardpathArray=${params.get('backwardpathArray')}`
            : ''
        }`
      );
    }
  };

  const previousClick = () => {
    const currentIndex = array.indexOf(id);
    if (currentIndex > 0 && currentIndex < array.length)
      navigate(
        `/candidate-layout/${pageType ? pageType : 'profile'}?id=${
          array[currentIndex - 1]
        }&array=${array}${
          params.get('backwardpathArray')
            ? `&backwardpathArray=${params.get('backwardpathArray')}`
            : ''
        }`
      );
  };

  const copy = (value) => {
    copyStringToClipboard(value);
    setNotification(success('Copied Successfully !!'));
  };
  const openUrlInNewTab = (url: string) => {
    const newWindow =
      url.indexOf('http') > -1 || url.indexOf('https') > -1
        ? window.open(url, '_blank', 'noopener,noreferrer')
        : window.open('//' + url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  const linkedInOrProfileUrl = candidate?.linkedInURL || candidate?.profileURLs?.[0];

  return (
    <>
      <Box bgcolor={WsColors.TheBlues900} borderRadius={1.5} p={1} pl={2} width="100%">
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item xs={7.5}>
            <Grid container justifyContent="flex-start" spacing={1} alignItems="center">
              <Grid item>
                <CircularImage src={candidate?.profileImage ?? ''} />
              </Grid>
              <Grid item>
                <WsTypography color={WsTypoColors.WHITE} variant={WsTypoVariants.TITLE} bold>
                  {candidate?.name}
                </WsTypography>
              </Grid>
              {isInDnc && (
                <>
                  <Grid item ml={2}>
                    <WsChip
                      icon={<MdDoNotDisturbOn color={WsColors.Red400} />}
                      value="Do Not Contact"
                      variant={WsChipVariants.INVALID}
                    />
                  </Grid>
                  <Grid item ml={2}>
                    <Chip
                      icon={<SellOutlinedIcon fontSize="small" />}
                      sx={{ borderRadius: 1, backgroundColor: WsColors.White }}
                      label={dncTypes.get(candidateDncType)}
                      size="medium"
                    />
                  </Grid>
                </>
              )}
              {!isInDnc && candidate?.email && (
                <Grid item ml={3}>
                  <WsElementWithPopOver
                    element={
                      <WsIconText
                        icon={<EmailOutlinedIcon style={{ color: WsColors.White, fontSize: 20 }} />}
                        text={candidate?.email ?? ''}
                        textSize={WsTypoVariants.BODY1}
                        textColor={WsTypoColors.WHITE}
                        textCursor="pointer"
                      />
                    }
                  >
                    <Grid container direction="column" p={1.5}>
                      <Grid item>
                        <WsButton
                          startIcon={<WsIconEmailOutlined />}
                          onClick={() => {
                            updateAction('email');
                            setOpenConvoWidget(true);
                            amplitude('CandidateView_Banner_Email', {
                              clickedOn: 'Email',
                              pageName: 'candidate-layout',
                              pageUrl: window.location.href,
                            });
                          }}
                          size="small"
                          variant="text"
                        >
                          Send Email
                        </WsButton>
                      </Grid>
                      <Grid item>
                        <WsButton
                          startIcon={<WsIconCopy />}
                          onClick={() => copy(candidate?.email ?? '')}
                          variant="text"
                          size="small"
                        >
                          Copy
                        </WsButton>
                      </Grid>
                    </Grid>
                  </WsElementWithPopOver>
                </Grid>
              )}
              {!isInDnc && candidate?.phoneNumber && (
                <Grid item ml={3}>
                  <WsElementWithPopOver
                    element={
                      <WsIconText
                        icon={
                          <LocalPhoneOutlinedIcon style={{ color: WsColors.White, fontSize: 20 }} />
                        }
                        text={formattedPhone ?? candidate?.phoneNumber}
                        textSize={WsTypoVariants.BODY1}
                        textColor={WsTypoColors.WHITE}
                        textCursor="pointer"
                      />
                    }
                  >
                    <Grid container direction="column" p={1.5}>
                      <Grid item>
                        <WsButton
                          startIcon={<WsIconEmailOutlined />}
                          onClick={() => {
                            updateAction('sms');
                            setOpenConvoWidget(true);
                            amplitude('CandidateView_Banner_SMS', {
                              clickedOn: 'Message',
                              pageName: 'candidate-layout',
                              pageUrl: window.location.href,
                            });
                          }}
                          size="small"
                          variant="text"
                        >
                          Send SMS
                        </WsButton>
                      </Grid>
                      <Grid item>
                        <WsButton
                          startIcon={<WsIconCopy />}
                          onClick={() => copy(formattedPhone ?? candidate?.phoneNumber)}
                          variant="text"
                          size="small"
                        >
                          Copy
                        </WsButton>
                      </Grid>
                    </Grid>
                  </WsElementWithPopOver>
                </Grid>
              )}
              {linkedInOrProfileUrl && (
                <Grid item mt={1}>
                  <WsElementWithPopOver
                    element={<Img src={getSocialIconByURL(linkedInOrProfileUrl)} />}
                  >
                    <Grid container direction="column" p={1.5}>
                      <Grid item>
                        <WsButton
                          startIcon={<LuExternalLink color={WsColors.TertiaryShades800} />}
                          onClick={() => openUrlInNewTab(linkedInOrProfileUrl)}
                          size="small"
                          variant="text"
                        >
                          Open In a New Tab
                        </WsButton>
                      </Grid>
                      <Grid item>
                        <WsButton
                          startIcon={<WsIconCopy />}
                          onClick={() => copy(linkedInOrProfileUrl)}
                          variant="text"
                          size="small"
                        >
                          Copy Link
                        </WsButton>
                      </Grid>
                    </Grid>
                  </WsElementWithPopOver>
                </Grid>
              )}
              {candidate?.personalWebsite && (
                <Grid item mt={1}>
                  <PersonIcon
                    fontSize="medium"
                    color="primary"
                    onClick={() => openUrlInNewTab(candidate?.personalWebsite ?? '')}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs={4} gap={1} display="flex" alignItems="center" justifyContent="flex-end">
            <IconBox sx={{ background: '#1F2070' }}>
              {icons.map((item, index) => (
                <>
                  <Tooltip title={item.title}>
                    <IconButton
                      key={index}
                      sx={{
                        color: WsColors.TheBlues500,
                        p: 1.5,
                        '&.Mui-disabled': {
                          color: WsColors.TertiaryShades500,
                        },
                      }}
                      onClick={() => item.onclick && item.onclick()}
                      disabled={
                        (isInDnc && item.title !== 'Data Privacy') ||
                        (item.title === 'Recruiter Questions' &&
                          isEmpty(selectedJob && selectedJob?.questions))
                      }
                    >
                      {item.icon}
                    </IconButton>
                  </Tooltip>
                  {index < icons.length - 1 && (
                    <Divider
                      orientation="vertical"
                      variant="middle"
                      sx={{
                        borderColor: 'white',
                        opacity: 0.2,
                        borderWidth: 1,
                        height: 25,
                      }}
                    />
                  )}
                </>
              ))}
            </IconBox>
            {array.length > 1 && (
              <>
                <WsButton
                  variant="outlined"
                  startIcon={<MdOutlineArrowBackIos />}
                  onClick={() => {
                    previousClick();
                    amplitude('CandidateView_Banner_Prev', {
                      clickedOn: 'Prev',
                      pageName: 'candidate-layout',
                      pageUrl: window.location.href,
                    });
                  }}
                >
                  <></>
                </WsButton>
                <WsButton
                  variant="contained"
                  endIcon={<MdOutlineArrowForwardIos />}
                  onClick={() => {
                    nextClick();
                    amplitude('CandidateView_Banner_Next', {
                      clickedOn: 'Next',
                      pageName: 'candidate-layout',
                      pageUrl: window.location.href,
                    });
                  }}
                >
                  <></>
                </WsButton>
              </>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item container spacing={1} alignItems="center">
            {candidate?.latestEmailStatus === 'Bounced' && (
              <Grid item>
                <Chip
                  icon={<SellOutlinedIcon fontSize="small" />}
                  style={{ borderRadius: 4, backgroundColor: WsColors.White }}
                  label="Email Bounced"
                  size="small"
                />
              </Grid>
            )}
            {candidate?.tags &&
              candidate?.tags?.slice(0, displayListLimit).map((chipName, index) => (
                <Grid item key={index}>
                  <Chip
                    icon={<SellOutlinedIcon fontSize="small" />}
                    style={{ borderRadius: 4, backgroundColor: WsColors.White }}
                    label={chipName}
                    size="small"
                  />
                </Grid>
              ))}
            <Grid item>
              {candidate?.tags && candidate?.tags?.length > 2 && (
                <WsButton
                  variant="text"
                  size="medium"
                  onClick={() =>
                    setDisplayLimit(
                      candidate?.tags?.length !== undefined &&
                        displayListLimit == candidate?.tags?.length
                        ? 2
                        : candidate?.tags?.length ?? 0
                    )
                  }
                >
                  {displayListLimit < candidate?.tags?.length
                    ? `+ ${candidate?.tags?.length - displayListLimit} more`
                    : 'show less'}
                </WsButton>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {openDNC && (
        <WsDrawer open={openDNC} onClose={() => setOpenDNC(!openDNC)}>
          <DataPrivacy
            email={candidate?.email ?? ''}
            candidateName={candidate?.name ?? ''}
            isInDnc={candidate?.isInDnc ?? candidate?.dncDetails?.isInDnc ?? false}
            dncDetails={candidate?.dncDetails}
          />
        </WsDrawer>
      )}
      {openDialog && candidate && (
        <>
          <WsDrawer
            open={openDialog}
            title="Edit Profile"
            style={{ zIndex: '1300' }}
            onClose={() => setOpenDialog(false)}
            size="large"
          >
            <CandidateProfileDetailsEdit close={() => setOpenDialog(false)} candidate={candidate} />
          </WsDrawer>
        </>
      )}
      {/* {candidate && (
        <MergeCandidate
          open={true}
          onClose={() => {}}
          candidate={candidateViewData?}
          mergeCandidate={candidateViewData?}
          fields={mergeFields}
        />
      )} */}
    </>
  );
};

export default TopBanner;
